// extracted by mini-css-extract-plugin
module.exports = {"sharePopover":"cm","shareText":"cn","show":"co"};